<template>
  <div class="scroll popups" @click.stop="close" v-show="showPopup">
    <div
      class="bg-FFFFFF w-full fb fb-col popup"
      :class="showPopup ? 'show-popups' : 'hide-popups'"
      @click.stop="handlerClickPopup"
    >
      <div
        class="bb font-32 relative fb fb-row fb-cross-center fb-main-between popup-header"
      >
        <div class="lh-46 bb font-32 c-000 ff-semibol mb-16 help-head">
          {{ content.title }}
          <i
            class="iconfont font-32 c-191F25-80 mr-24 popup-close"
            @click.stop="close"
            >&#xe605;</i
          >
        </div>
      </div>

      <div class="p-8-0 p-0-8 scroll item-flex-1 popup-content">
        <div class="p-0-16 p-16-0 ff-regular">
          <p
            class="mb-16 c-3296FA font-32"
            v-if="showLink"
            @click="handlerLinkList"
          >
            点击查看更多说明
          </p>
          <div class="font-32 pb-20 c-000 lh-25 pt-46">
            <div
              v-for="(item, index) in detail"
              :key="index"
              class="lh-24 pb-10"
              v-html="item"
            >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HELP_DATA } from '@/utils/helpConst'
import mixin from '@/mixin'
import { LEAVE_ROLE } from '@/utils/constUtils'
export default {
  mixins: [mixin],
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false
    },
    link: {
      type: [String],
      default: ''
    },
    showLink: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showPopup: this.show,
      HELP_DATA: HELP_DATA,
      content: {},
      detail: {},
      role: 0,
      level: {
        1: 'guardian',
        2: 'headmaster',
        3: 'admin'
      }
    }
  },
  watch: {
    show(show) {
      this.showPopup = show
    },
    link(link) {
      let _detail = HELP_DATA[link]
      this.content = _detail
      this.detail = _detail.data[this.level[this.role]]
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.initData()
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    initData() {
      let _detail = HELP_DATA[this.link]
      if (this.link === 'leaveProcess') {
        _detail = _detail()
      }
      this.content = _detail
      if (this.curIsAdmin) {
        this.role = LEAVE_ROLE.admin
      } else if (this.curIsCampusHeadmaster) {
        this.role = LEAVE_ROLE.headmaster
      } else if (this.curIsGuardian) {
        this.role = LEAVE_ROLE.guardian
      }
      this.detail = _detail.data[this.level[this.role]]
    },
    close() {
      this.showPopup = false
      this.$emit('close', false)
    },
    handlerLinkList() {
      this.$router.replace({
        path: '/helpIndex'
      })
    },
    handlerClickPopup() {
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.popups {
  background: rgba(0, 0, 0, 0.28);
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  .popup {
    transition: all ease 0.6s;
    border-radius: 11px 11px 0px 0px;
    position: absolute;
    left: 0;
    bottom: -100vh;
    max-height: 80%;
    width: 100%;
  }
  .popup-close {
    position: absolute;
    top: 23px;
    transform: translateY(-50%);
    right: -16px;
    padding: 0 16px;
  }
  .hide-popups {
    bottom: -100vh;
  }
  .show-popups {
    bottom: 0;
  }
  .popup-header {
    z-index: 999999;
    border-radius: 11px 11px 0px 0px;
  }
  .help-head {
    width: 100%;
    border-radius: 11px 11px 0px 0px;
    position: fixed;
    top: 20%;
    left: 0;
    background: #fff;
    padding-left: 16px;
    z-index: 9999;
  }
  .help-title {
    line-height: 20px;
    padding: 12px 0;
    border-bottom: 1px solid #ededed;
    span {
      display: inline-block;
      padding-left: 4px;
      border-left: 4px solid #3296fa;
      font-family: PingFangSC-Semibold;
      font-size: 18px;
      color: #000;
      letter-spacing: 0;
    }
  }
}
</style>
